/**
 * 图片优化配置文件
 *
 * 在这里配置需要进行图片优化的域名
 * 支持阿里云 OSS 图片处理服务
 */

/**
 * 需要进行图片优化的域名列表
 *
 * 如何添加新域名：
 * 1. 确保域名使用了阿里云 OSS 或支持图片处理的 CDN
 * 2. 在下面的数组中添加域名
 * 3. 重启开发服务器
 *
 * @type {string[]}
 */
export const OPTIMIZED_DOMAINS = [
  // 项目主要 CDN 域名
  "static.edwealth.ai",

  // 阿里云 OSS 域名
  "osp-temp.oss-accelerate.aliyuncs.com",

  // 其他阿里云相关域名（如果需要）
  // 'your-bucket.oss-cn-hangzhou.aliyuncs.com',
  // 'your-custom-cdn.alicdn.com',
];

/**
 * 图片优化默认配置
 *
 * 基于阿里云 CDN 官方文档参数
 * 可根据实际需求调整这些参数
 */
export const IMAGE_OPTIMIZATION_CONFIG = {
  // 默认质量 (1-100)
  // 75 是质量和文件大小的最佳平衡点
  defaultQuality: 75,

  // 是否启用 WebP 格式转换
  // WebP 可减少约 30% 的文件大小
  enableWebP: true,

  // 是否启用图片锐化
  // 锐化值范围：50-399，100 为轻微锐化
  enableSharpen: true,
  sharpenValue: 100,

  // 不同场景的质量配置
  qualityPresets: {
    thumbnail: 70, // 缩略图
    normal: 75, // 常规图片
    high: 85, // 高质量图片
    original: 95, // 接近原图
  },
};

/**
 * 不需要优化的图片格式
 *
 * SVG 是矢量图形，GIF 需要保留动画
 * 这些格式会直接返回原始 URL
 *
 * @type {string[]}
 */
export const SKIP_OPTIMIZATION_FORMATS = [
  ".svg", // 矢量图形，无需尺寸优化
  ".gif", // 动画图片，需要保留帧序列
  ".ico", // 图标文件
];

/**
 * 检查域名是否需要优化
 * @param {string} url - 图片 URL
 * @returns {boolean}
 */
export function shouldOptimizeImage(url) {
  return OPTIMIZED_DOMAINS.some((domain) => url.includes(domain));
}
